<template>
  <v-text-field outlined ref="input" autofocus v-model="model" :label="placeholder" />
</template>

<script>
export default {
  data: () => ({
    autocomplete: '',
  }),
  props: {
    value: String,
    types: {
      type: Array,
      default() {
        return ['(cities)'];
      },
    },
    placeholder: String,
    componentRestrictions: {
      type: Object,
      default() {
        return {
          country: 'us',
        };
      },
    },
    componentForm: {
      type: Object,
      default() {
        return {
          locality: 'long_name',
          administrative_area_level_1: 'long_name',
        };
      },
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    initAutocomplete() {
      this.autocomplete = new window.google.maps.places.Autocomplete(
        this.$refs.input.$el.querySelector('input'),
        {
          types: this.types,
          componentRestrictions: this.componentRestrictions,
        },
      );
      this.autocomplete.setFields(['address_component']);
      this.autocomplete.addListener('place_changed', this.fillInAddress);
    },
    fillInAddress() {
      const place = this.autocomplete.getPlace();
      const fieldValue = [];

      place.address_components.forEach((component) => {
        const [addressType] = component.types;

        if (this.componentForm[addressType]) {
          fieldValue.push(component[this.componentForm[addressType]]);
        }
      });

      this.$emit('input', fieldValue.join(', '));
    },
  },
  mounted() {
    this.initAutocomplete();
  },
  beforeDestroy() {
    this.autocomplete = '';
  },
};
</script>
<style lang="scss" scoped>
::v-deep input::placeholder{
  opacity: 0;
}
</style>